// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kind-spezialwunsch-container {
  margin-bottom: 2rem;
}

.feedback {
  margin-bottom: 1rem;
}

.feedback.success {
  color: var(--dunkelgruen);
}

.feedback.error {
  color: var(--blutorange);
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

.intro-paragraph {
  font-family: 'Circular', sans-serif;
  font-weight: normal;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/kind_spezialwunsch/KindSpezialwunsch.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".kind-spezialwunsch-container {\n  margin-bottom: 2rem;\n}\n\n.feedback {\n  margin-bottom: 1rem;\n}\n\n.feedback.success {\n  color: var(--dunkelgruen);\n}\n\n.feedback.error {\n  color: var(--blutorange);\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.intro-paragraph {\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
